import {Checkbox} from "@mui/material";
import React, {useEffect} from "react";

export interface IVeneCheckboxState {
    checked: number;
    onClick: (returnedState: number) => void;
}

export const VeneCheckbox = (props: IVeneCheckboxState) => {
    const [checkboxState, setCheckboxState] = React.useState<number>(0);

    useEffect(() => {
        setCheckboxState(props.checked)
    }, [props.checked]);
    
    const handleCheckboxState = () => {
        const currentState = checkboxState;
        let newState: 0 | 1 | 2 = 0;
        
        switch (currentState) {
            case 0:
                newState = 1;
                break;
            case 1:
                newState = 2;
                break;
            case 2:
                newState = 0;
                break;
            default:
                newState = 0
        }
        
        setCheckboxState(newState);
        props.onClick(newState);
    }
    
    const setCheckboxClass = () => {
        switch (checkboxState) {
            case 0:
                return 'state_0'
            case 1:
                return 'state_1'
            case 2:
                return 'state_2'
        }
    }
    
    return (
        <div className='vene_checkbox_outer_circle'>
            <div className={'vene_checkbox ' + setCheckboxClass()} onClick={handleCheckboxState}/>
        </div>

    )
}